import React, {useState} from 'react';
import {NavLink} from "react-router-dom";
import StandardAdminBrowserLayout from "../../platform/browser/StandardAdminBrowserLayout";
import TableBrowserResultsComponent from "../../platform/browser/TableBrowserResultsComponent";
import StandardBrowserPaginationComponent from "../../platform/browser/StandardBrowserPaginationComponent";
import UBoldModal from "../../ubold-components/UBoldModal";
import BrowserContainer from "../../platform/browser/BrowserContainer";
import AjaxService from "../../platform/ajax/AjaxService";
import {createInternationalizationPrefixer} from "../i18n/i18n";

const t = createInternationalizationPrefixer("ActivateUserAccountsPage");

const cardSubHeader = "Tutaj możesz dokonać aktywacji użytkowników - czyli zarejestrowanych aktywnych kont nie posiadających żadnej roli. Osoby te mogą zalogować się do systemu, ale zobaczą ostrzeżenie, że konto nie jest jeszcze w pełni aktywne i jedyną możliwością dostępną jest wylogowanie lub zmiana hasła.";


export default function ActivateUserAccountsPage(props) {

    const [idToDelete, setIdToDelete] = useState(null);

    const customCellRenderers = {
        name: result => <strong>{result.name}</strong>,
        actions: result => <div className="text-center">
            <NavLink className="action-icon" to={"/accounts/change-entitlements/" + result.id}> <i className="fas fa-user-shield"></i> {t('Nadaj rolę')}</NavLink>
            <a className="action-icon" href="#" onClick={() => setIdToDelete(result.id)}> <i className="fas fa-trash-alt"></i> {t('Usuń')}</a>
        </div>
    };

    const tableHeaderMapping = {
        email: t('E-mail'),
        name: t('Nazwa'),
        actions: <th key={"actions"} className={"text-center"}>{t('Akcje')}</th>,
    };

    const browserLayoutFactory = (browserData) =>
        <StandardAdminBrowserLayout
            header={"Aktywacja użytkowników"}
            subHeader={cardSubHeader}
            resultsComponent={<TableBrowserResultsComponent
                results={browserData.results}
                fetching={browserData.fetching}
                striped={true}
                headerMapping={tableHeaderMapping}
                customCellRenderers={customCellRenderers}
                noResultsContent={<div className="text-center mt-4 h4 text-muted">{t('Brak wyników')}</div>}
            />}
            paginationComponent={<StandardBrowserPaginationComponent
                criteria={browserData.criteria}
                fetching={browserData.fetching}
                results={browserData.results}
                onCriteriaChange={browserData.changeCriteriaListener}/>}
        />;

    const commitDeletion = id => {
        AjaxService.delete("/api/user-account/" + id).then(response => {
            if (response.ok) {
                setIdToDelete(null);
                window.location.reload(false);
            }
        });
    };

    return [
        <UBoldModal key={1} opened={idToDelete !== null} onClose={() => setIdToDelete(null)}
                    header={t("Czy na pewno usunąć?")}>
            <div className="text-center">
                <button className="btn btn-warning mr-2"
                        onClick={() => commitDeletion(idToDelete)}>Tak
                </button>
                <button className="btn btn-primary" onClick={() => setIdToDelete(null)}>{t('Anuluj')}</button>
            </div>
        </UBoldModal>,
        <BrowserContainer
            key={2}
            url={"/api/user-account/without-roles"}
            initialCriteria={{limit: 10, offset: 0}}
            layoutComponentFactory={browserLayoutFactory}/>];
}
